import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { searchArticles } from '../mockData';
import ArticleCard from '../components/ArticleCard';
import { Search } from 'lucide-react';

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (query) {
      const searchResults = searchArticles(query);
      setResults(searchResults);
    }
  }, [query]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Search Header */}
      <div className="mb-12">
        <div className="flex items-center gap-3 mb-4">
          <Search size={32} className="text-gray-600" />
          <h1 className="text-4xl font-serif font-bold">
            Search Results
          </h1>
        </div>
        <p className="text-gray-600 text-lg">
          Found {results.length} {results.length === 1 ? 'result' : 'results'} for "{query}"
        </p>
      </div>

      {/* Results */}
      {results.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {results.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      ) : (
        <div className="text-center py-16">
          <p className="text-gray-600 text-lg mb-4">
            No articles found for "{query}"
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-semibold"
          >
            Back to Homepage
          </Link>
        </div>
      )}
    </div>
  );
};

export default SearchPage;